export default "/images/65c6c91af82ae1856141b4d8b674b6d2.avif";